export default __webpack_public_path__ + "static/media/info.ad739217.svg";